import { useFeatureFlagsContext } from "src/utils/FeatureFlags/FeatureFlagsContext";

export const isFlagActive = (featureFlags, feature) =>
  featureFlags.find((flag) => flag.name === feature)?.active || false;

export const useFeatureFlags = () => {
  const featureFlags = useFeatureFlagsContext();
  return featureFlags;
};
